module.exports = __webpack_public_path__ + "img/foot-wechat.ee10be9f.png";